import React, {useState, 
               useEffect, 
               useContext}          from 'react';
import { Card }                     from 'react-bootstrap';
import GoalProgressUpdateMG         from './GoalProgressUpdateMG';
import GoalProgressUpdateDC         from './GoalProgressUpdateDC';
import GoalProgressUpdateDQT        from './GoalProgressUpdateDQT';
import GoalProgressUpdateDXY        from './GoalProgressUpdateDXY';
import GoalProgressUpdateCL         from './GoalProgressUpdateCL';
import { useNavigate }              from 'react-router-dom';
import { BsBarChartLineFill,
         BsArrowLeftSquareFill,
         BsFillCaretDownFill,
         BsFillCaretUpFill}    from 'react-icons/bs';
import { SelectionContext }         from './SelectionContext';

function GoalProgressUpdate( { selGoal, refresh } ) {
  const [goal, setGoal] = useState( { goal_type: 0 } );
  const navigate        = useNavigate();
  const { getExpandedCLSummary, 
          toggleExpandedCLSummary}  = useContext(SelectionContext);
         
  useEffect(() => {
    if (selGoal) {
        setGoal(selGoal);
    }
  }, [selGoal]); // Runs when initialData changes

  const handleReview = (id) => {
        navigate('/review-goal', { state: { id } });     
  };

  const handleBack = () => {
        navigate('/status');     
  };

  const requestRefresh = () => {
      refresh();
  };

  const handleExp = () => {
      toggleExpandedCLSummary();
  };
         
  return(
      <Card>
      <Card.Header className="card-goal-header">
        <Card.Title>
          <div class="content-container">
            <div class="left-content d-flex align-items-center">
              Goal Progress
            </div>
            <div class="right-content">
              <BsArrowLeftSquareFill onClick={() => handleBack()}/>
              <BsBarChartLineFill onClick={() => handleReview(goal.id)}/>
              { goal.goal_type === 6 && getExpandedCLSummary() === true  && ( <BsFillCaretUpFill   onClick={() => handleExp()} /> )}
              { goal.goal_type === 6 && getExpandedCLSummary() === false && ( <BsFillCaretDownFill onClick={() => handleExp()} /> )}
            </div>
          </div>
        </Card.Title>
        <Card.Subtitle className="text-center">{goal.goal_title}</Card.Subtitle>
        <Card.Subtitle className="text-center">{goal.goal_description}</Card.Subtitle>
      </Card.Header>
        <Card.Body>
        { goal.goal_type === 1 && ( <GoalProgressUpdateMG  goal = { goal } /> ) }    
        { goal.goal_type === 2 && ( <GoalProgressUpdateDC  selGoal={goal} refresh={requestRefresh} /> ) }    
        { goal.goal_type === 3 && ( <GoalProgressUpdateDQT selGoal={goal} refresh={requestRefresh} /> ) }    
        { goal.goal_type === 4 && ( <GoalProgressUpdateDXY selGoal={goal} refresh={requestRefresh} /> ) }    
        { goal.goal_type === 5 && ( <GoalProgressUpdateDXY selGoal={goal} refresh={requestRefresh} /> ) }    
        { goal.goal_type === 6 && ( <GoalProgressUpdateCL  selGoal={goal} refresh={requestRefresh} /> ) }    
        </Card.Body>
      </Card>
  );
}

export default GoalProgressUpdate;
